module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#mynews",
      toString: function () {
        return this.url;
      }
    }